module.exports = __webpack_public_path__ + "static/media/clusterIcon1.1eddb0de.png";